var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "h-full",
    viewBox: "0 0 29 28",
    fill: "#FF0000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2423 24.8192L26.3366 20.0797C26.4551 19.5647 26.1861 19.0361 25.7028 18.8265L20.5961 16.639C20.1493 16.4476 19.6249 16.5752 19.3194 16.9535L17.0579 19.7151C13.5607 18.0745 10.6517 15.208 8.97831 11.6398L11.7414 9.3794C12.1199 9.06951 12.2475 8.54999 12.056 8.10338L9.86743 2.99932C9.65313 2.5117 9.12422 2.24283 8.60899 2.36131L3.86703 3.45504C3.3746 3.56897 3.01895 4.00646 3.01895 4.52142C3.01895 16.1924 12.4801 25.6668 24.1754 25.6668C24.686 25.6668 25.1283 25.3159 25.2423 24.8192Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.863211e44558efac95b9982d83974dc2.svg";
export { ForwardRef as ReactComponent };